export default __webpack_public_path__ + "static/media/ekedc.8566011a.png";